import type { TFunction } from 'i18next';
import {
  convertBytesToHumanizedNumber,
  getDecimalOfNumber,
  getFileSizePow10,
  getFileSuffixFromPow,
} from '@ingenico/util-common';
import type { ApplicationResourceArtifact } from '../domain/models/applicationVersion.model';
import type { FileOsVersion } from '../domain/models/osVersion.model';
import type { SystemPackageResourceArtifact } from '../domain/models/systemPackage.model';

export function formatBytes(bytes: number, t: TFunction, decimals = 2) {
  if (!+bytes) {
    return '0 Bytes';
  }

  const decimalPlaces = decimals < 0 ? 0 : decimals;
  const decimal = getDecimalOfNumber(Math.log2(Math.max(bytes, 1)));
  const suffix = getFileSuffixFromPow(getFileSizePow10(decimal));
  const translationKey = suffix === 'B' ? 'bytes' : suffix.toLowerCase();
  const translatedSuffix = t(`byteSizeUnit.${translationKey}`);

  const humanizedNumber = Number.parseFloat(convertBytesToHumanizedNumber(bytes));

  return `${Number.parseFloat(humanizedNumber.toFixed(decimalPlaces))} ${translatedSuffix}`;
}

export function getTotalSize(
  files: ApplicationResourceArtifact[] | FileOsVersion[] | SystemPackageResourceArtifact[],
): number {
  const buffer = (files as Array<{ size: number }>).reduce((acc, file) => acc + (file?.size ?? 0), 0);
  return Math.round((buffer + Number.EPSILON) * 100) / 100;
}
